export const indicatorStyles = {
  cursor: 'pointer',
  color: 'info.main',
  display: 'inline-flex',
  verticalAlign: 'middle',
  marginLeft: '4px',
  '&:hover': {
    color: 'primary.main',
  },
};

export const matchIndicatorStyles = {
  cursor: 'pointer',
  color: 'success.main',
  display: 'inline-flex',
  verticalAlign: 'middle',
  marginLeft: '4px',
  opacity: 0.7,
  '&:hover': {
    opacity: 1,
  },
};

export const indicatorWrapperStyles = {
  display: 'inline-flex',
};

export const applyButtonStyles = {
  minWidth: 'auto',
  textTransform: 'none',
};

export const getPopoverContentStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '10px 14px',
  backgroundColor: theme.palette.info.extraSoft,
  border: '1px solid',
  borderColor: theme.palette.info.main,
  borderRadius: theme.shape.radius.l,
  maxWidth: '280px',
});

export const getMatchPopoverContentStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '10px 14px',
  backgroundColor: theme.palette.success.extraSoft,
  border: '1px solid',
  borderColor: theme.palette.success.main,
  borderRadius: theme.shape.radius.l,
  maxWidth: '280px',
});

export const popoverFooterStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '2px',
};

export const getPopoverSlotProps = theme => ({
  paper: {
    elevation: 4,
    sx: {
      borderRadius: theme.shape.radius.l,
      overflow: 'visible',
      backgroundColor: 'transparent',
    },
  },
});
